import React, { Component } from "react";

import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ApplicatedQuestion from "../ApplicatedQuestion/ApplicatedQuestion";

class QuestionViewerModal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        size="xl"
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle className="m-0">Visualizador de questão</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <ApplicatedQuestion
            questionId={this.props.question}
            listId={this.props.list}
            prototype
            finished={false}
            editable={false}
            className="mb-0"
          />
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  note: state.note
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionViewerModal);
